var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chart',{staticClass:"teambar",attrs:{"options":_vm.baroptions,"autoresize":""}})}
var staticRenderFns = []

export { render, staticRenderFns }